<template>
  <div class="layerWrap" style="display: block" v-if="message">
    <div class="layerRow" :class="{ 'layer-dim': isDim }">
      <div class="layerCell">
        <div class="layerIn">
          <img
            class="img"
            v-if="imgFlag === undefined ? true : imgFlag"
            src="@/assets/img/ic_error_60.png"
          />

          <div class="layerHd" v-if="allDeliveryFlag != 2">
            <h1 class="hTit">
              {{ $t(message.title || '') }}
            </h1>
          </div>

          <div class="layerCont">
            <p
              class="layerCnt_tit"
              style="white-space: pre-line"
              v-if="allDeliveryFlag != 2"
            >
              {{ $t(message.content || '') }}
            </p>
            <p class="layerCnt_txt point1" style="white-space: pre-line">
              {{ $t(message.firstLine || '') }}
            </p>
            <p class="layerCnt_txt" style="white-space: pre-line">
              {{ $t(message.secondLine || '') }}
            </p>
          </div>

          <div class="layerBtm2" :class="{ 'btn-col': btnCol }">
            <ul>
              <li>
                <button type="button" class="btn" @click="$emit('useNewAuth')">
                  {{ $t(message.btnType[0]) }}
                </button>
              </li>
              <li v-if="message.btnType && message.btnType.length > 1">
                <button type="button" class="btn gr" @click="$emit('retryOldAuth')"> 
                  {{ $t(message.btnType[1]) }}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SafeDoubleBtnDialog',
  props: {
    message: { type: Object, required: true },
    allDeliveryFlag: { type: Number, default: 0 },
    imgFlag: { type: Boolean, default: true },
    isDim: { type: Boolean, default: true },
    btnCol: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
/* 제공해주신 CSS를 그대로 유지했습니다. */
.layerWrap .layerBtm2 .btn{
      font-size: 1.4rem;
    color: #fff;
    line-height: 50px;
    width: 100%;
    background: var(--primary);
    margin-bottom: 1rem;
}
/* 주석 처리된 CSS도 그대로 유지했습니다.
.layerWrap .layerBtm2 ul{
   display: flex;
    width: 100%;
    flex-direction: column;
    align-items: stretch;
}
.layerWrap .layerBtm2 li {
    display: flex;
    width: 100%;
}
.layerWrap .layerBtm2 li+li {
    padding: 0 0 0 0px;
margin-top: 4px;
} 
*/
</style>